import { Routes, Route } from "react-router-dom";
import { isAuth } from "../helpers/cookies";
import { ROLES } from "../helpers/constants";

// admin routes
import DashboardView from "../pages/admin/Dashboard";
import RegionsView from "../pages/admin/Regions";
import UsersView from "../pages/admin/Users";
import ProductsView from "../pages/admin/Products";
import OrdersView from "../pages/admin/Orders";
import TrackingView from "../pages/admin/Tracking";
import WarrantyView from "../pages/admin/Warranty";
import InsuranceView from "../pages/admin/Insurance";
import CustomerMasterView from "../pages/admin/CustomerMaster";
import ReportsView from "../pages/admin/Reports";
import AlertsView from "../pages/admin/Alerts";
// import StockieUsersView from "../pages/admin/StockieUsers";
// import DistributorUsersView from "../pages/admin/DistributorUsers";
// import ICategoryView from "../pages/admin/ICategory";
// import CategoryView from "../pages/admin/Category";
// import ProductTypesView from "../pages/admin/ProductTypes";
// import ProductImageView from "../pages/admin/ProductImage";
// import SupplierTypesView from "../pages/admin/SupplierTypes";
// import CertifiedView from "../pages/admin/Certified";

// subadmin routes
// import SuppliersView from "../pages/subadmin/Suppliers";
// import ProductsView from "../pages/subadmin/Products";
// import SupplierProductsView from "../pages/subadmin/SupplierProducts";
// import SupplierProductsAddView from "../pages/subadmin/SupplierProductsAdd";

const AdminRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<DashboardView />} />
            <Route path="/dashboard" element={<DashboardView />} />
            <Route path="/regions" element={<RegionsView />} />
            <Route path="/users" element={<UsersView />} />
            <Route path="/products" element={<ProductsView />} />
            <Route path="/orders" element={<OrdersView />} />
            <Route path="/tracking" element={<TrackingView />} />
            <Route path="/warranty" element={<WarrantyView />} />
            <Route path="/insurance" element={<InsuranceView />} />
            <Route path="/customer-master" element={<CustomerMasterView />} />
            <Route path="/reports" element={<ReportsView />} />
            <Route path="/alerts" element={<AlertsView />} />
        </Routes>
    );
};

export default AdminRoutes;
